import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import AsYouType, {
  getCountryCallingCode,
} from "libphonenumber-js";
import {
  COUNTRY_PHONE_CODE,
  // ACCOUNT_TYPES,
  // INDIA_ACCOUNT_TYPES,
  // BENETYPES,
  EMAIL,
  BUSINESS_TYPES_FUNDINGlINK,
} from "../../../appconstants";
import {
  H2Text,
  LabelText,
  SpanText,
  Text,
  Input,
  InputWrapper,
  Hr,
} from "../../../design";
import {
  Row,
  Col,
} from 'antd';
import { ErrorMessage } from "@hookform/error-message";
import Select from "react-select";
import NumberFormat from "react-number-format";
import { isValidPhoneNumber } from 'libphonenumber-js';
import AddressFields from "./AddressFields";
import IndiaFields from "./IndiaFields";

type Props = {
  errors: Object,
  control: Object,
  errorMsg: String,
  watch: Function,
  trigger: Function,
  register: Function,
  setValue: Function,
  preFillCustomer: Object,
  customerDisabled: Boolean,
  customerValidation: Boolean,
  setShowErrorMessage: Function,
  otherFields: Array,
  alpha2: String,
  isMobileView: Boolean,
  customH2TextStyle: Object,
  customLabelTextStyle: Object,
};

const CommonFields = (props: Props) => {
  const {
    errors,
    control,
    errorMsg,
    watch,
    trigger,
    register,
    setValue,
    preFillCustomer,
    customerDisabled,
    customerValidation,
    setShowErrorMessage,
    alpha2,
    isMobileView,
    customH2TextStyle,
    customLabelTextStyle,
  } = props;

  const BACKGROUND_COLOR = '#f5f5f5';
  const COLOR = '#b8b8b8';

  useEffect(() => {
    if (preFillCustomer) {
      const phone = preFillCustomer && preFillCustomer.phoneNumber && AsYouType(preFillCustomer.phoneNumber);
      const countryCallingCode = (phone && `+${phone.countryCallingCode}`) || (alpha2 && `+${getCountryCallingCode(alpha2)}`);
      setValue('name', (preFillCustomer && preFillCustomer?.name) || '');
      setValue('email', (preFillCustomer && preFillCustomer?.email) || '');
      setValue('phone', (phone && phone?.nationalNumber) || '');
      setValue('countryCallingCode', (countryCallingCode && findCountryCallingCode(countryCallingCode)) || '');
      setValue('isDefault', false);
    }
  }, [preFillCustomer, setValue, alpha2]);

  useEffect(() => {
    if (errorMsg) {
      setShowErrorMessage(true);
    } else setShowErrorMessage(false);
  }, [errorMsg]);

  const findCountryCallingCode = (value) => (
    value && COUNTRY_PHONE_CODE.includes(value) && { value }
  );

  const isPhoneNumberValidate = (data) => {
    const countryCode = control?.getValues()?.countryCallingCode?.value;
    const phoneNum = control?.getValues()?.phone;
    if(!isValidPhoneNumber(`${countryCode}${phoneNum}`)) {
      return 'The phone number is invalid';
    }
  };

  const customInputStyle = {
    background: 'white',
    // color: 'black',
    borderColor: '#CCCCCC',
    width: '100%',
    height: '41px',
    paddingLeft: '15px',
  }

  const selectCustomStyles = {
    container: base => ({
      ...base,
      width: '100%',
      height: '41px',
      marginTop: '8px',
      marginBottom: '8px',
      borderRadius: '10px',
    }),
    control: base => ({
      ...base,
      height: '41px',
      minHeight: 33,
      border: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
    }),
    dropdownIndicator: base => ({
      ...base,
      height: 33,
      minHeight: 33,
    }),
  };

  const disableStyles = {
    container: base => ({
      height: '41px',
      width: '100px !important',
    }),
    control: base => ({
      ...base,
      height: '39px',
      minHeight: '39px',
      // width: '100px !important',
      border: 'none',
      borderRight: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
      background: '#f5f5f5',
      color: '#b8b8b8'
    }),
  };

  const phoneCustomStyles = {
    container: base => ({
      height: '41px',
      width: '100px !important',
      // maxWidth: '100px !important',
    }),
    control: base => ({
      ...base,
      height: '39px',
      minHeight: '39px',
      width: '100px !important',
      border: 'none',
      borderRight: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
    }),
  };

  return (
    <div
      // className="px-1 px-md-4 mt-2"
    >
      <Row>
        <Col span={24}>
          <H2Text
            {...customH2TextStyle}
          >
            YOUR CONTACT DETAILS
          </H2Text>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={isMobileView ? 24 : 12}>
          <LabelText {...customLabelTextStyle} style={{ color: 'black' }}>
            Name
          </LabelText>
          <Controller
            defaultValue={""}
            color={errors.name ? "red" : "inherit"}
            marginBottom="0px"
            control={control}
            name="name"
            placeholder="Enter your name"
            rules={customerValidation && {
              required: 'This field is required'
            }}
            as={<Input
              readOnly={customerDisabled}
              style={{
                ...customInputStyle,
                background: customerDisabled ? BACKGROUND_COLOR : '',
              }}
            />}
          />
          <ErrorMessage
            errors={errors}
            name="name"
            render={({ message }) => (
              <Text
                fontSize="12px"
                marginTop="4px"
                marginBottom="0px"
                color="#ff1e1e"
              >
                {message}
              </Text>
            )}
          />
        </Col>
        <Col span={isMobileView ? 24 : 12}>
          <LabelText {...customLabelTextStyle} style={{ color: 'black' }}>
            E-Mail
          </LabelText>
          <Controller
            marginBottom="0px"
            defaultValue={""}
            color={errors.email ? "red" : "inherit"}
            control={control}
            name="email"
            placeholder="Enter your email address"
            rules={customerValidation && {
              required: 'This field is required',
              pattern: {
                value: EMAIL.DEFAULT_REGEX,
                message: 'The email is invalid',
              },
            }}
            as={<Input
              readOnly={customerDisabled}
              style={{
                ...customInputStyle,
                background: customerDisabled ? BACKGROUND_COLOR : ''
              }}
            />}
          />
          <ErrorMessage
            errors={errors}
            name="email"
            render={({ message }) => (
              <Text
                fontSize="12px"
                marginTop="4px"
                marginBottom="0px"
                color="#ff1e1e"
              >
                {message}
              </Text>
            )}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={isMobileView ? 24 : 12}>
          <LabelText {...customLabelTextStyle} style={{ color: 'black' }}>
            Phone
          </LabelText>
          <InputWrapper
            className="row"
            display="flex"
            marginTop="8px"
            style={{
              ...customInputStyle,
              paddingLeft: 0,
            }}
          >
            <Controller
              defaultValue={""}
              color={errors.countryCallingCode ? "red" : "inherit"}
              marginBottom="0px"
              control={control}
              name="countryCallingCode"
              placeholder="select"
              rules={customerValidation && {
                required: 'Calling Code is required'
              }}
              as={<Select
                className="col-4 px-0 border-0"
                menuPlacement="auto"
                isSearchable={!customerDisabled}
                menuIsOpen={customerDisabled ? false : undefined}
                theme={theme => ({
                  ...theme,
                  borderRadius: "4px 0 0 4px",
                  boxShadow: 0
                })}
                getOptionLabel={(option) => option.value}
                styles={customerDisabled ? disableStyles : phoneCustomStyles}
                options={COUNTRY_PHONE_CODE.map(value => { return { value } })} />}
            />
            <Controller
              className="col"
              defaultValue={""}
              color={errors.phone ? "red" : "inherit"}
              border="0px !important"
              marginBottom="0px"
              marginTop="0px"
              marginLeft="0px"
              paddingRight="0"
              control={control}
              name="phone"
              rules={customerValidation && {
                required: 'This field is required',
                validate: isPhoneNumberValidate
              }}
              as={<NumberFormat
                type="tel"
                allowNegative={false}
                decimalScale={0}
                readOnly={customerDisabled}
                borderRadius="none"
                style={{
                  background: customerDisabled ? BACKGROUND_COLOR : '',
                  color: customerDisabled ? COLOR : '',
                  height: '99%',
                }}
              />}
              placeholder="Enter your phone number"
              customInput={Input}
            />
          </InputWrapper>
          <ErrorMessage
            errors={errors}
            name="phone"
            render={({ message }) => (
              <Text
                fontSize="12px"
                marginTop="4px"
                marginBottom="0px"
                color="#ff1e1e"
              >
                {message}
              </Text>
            )}
          />
        </Col>
      </Row>
      <Hr />
      <AddressFields
        customInputStyle={customInputStyle}
        disableStyles={disableStyles}
        customSelectStyle={selectCustomStyles}
        errors={errors}
        control={control}
        watch={watch}
        trigger={trigger}
        register={register}
        setValue={setValue}
        BACKGROUND_COLOR={BACKGROUND_COLOR}
        preFillCustomer={preFillCustomer}
      />
      {alpha2 === 'IN' && <Hr className="mt-3" />}
      <IndiaFields
        errors={errors}
        control={control}
        alpha2={alpha2}
        customerValidation={false}
        isMobileView={isMobileView}
        customH2TextStyle={customH2TextStyle}
        customLabelTextStyle={customLabelTextStyle}
      />
      {alpha2 === 'IN' && <Hr className="mt-3" />}
      <Row>
        <Col span={24}>
          <H2Text {...customH2TextStyle}>SELECT BUSINESS</H2Text>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <LabelText {...customLabelTextStyle} style={{ color: 'black' }}>
            Business Type
          </LabelText>
          <Controller
            defaultValue={""}
            color={errors.businessType ? "red" : "inherit"}
            marginBottom="0px"
            control={control}
            name="businessType"
            placeholder="select"
            rules={{
              required: 'Business type is required'
            }}
            as={<Select
              className="px-0 border-0"
              getOptionLabel={(option) => option.value}
              styles={selectCustomStyles}
              options={BUSINESS_TYPES_FUNDINGlINK.map(value => { return { value } }) } />}
          />
          <ErrorMessage
            errors={errors}
            name="businessType"
            render={({ message }) => (
              <Text
                fontSize="12px"
                marginTop="4px"
                marginBottom="0px"
                color="#ff1e1e"
              >
                {message}
              </Text>
            )}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <label>
            <Controller
              marginBottom="0px"
              name='isDefault'
              control={control}
              render={({ field }) => (
                <Input
                  type="checkbox"
                  width="auto"
                  onChange={(e) => setValue('isDefault', e.target.checked)}
                />
              )}
            />
            <SpanText
              className="pl-2"
            >
              Set as default bank account
            </SpanText>
          </label>
        </Col>
      </Row>
    </div>
  );
};

export default CommonFields;
